// TrialBalanceMapping.jsx
import React, { useState } from "react";
import axios from "axios";
import Select from "react-select";
import { Icon, Modal, Button } from "semantic-ui-react";
import { Fetchexecutequery, Fetchupdatequery,FetchUploadGl } from "../../../services/process/BRS1/brsService7";
import "../css/DynamicForm.css";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

function TrialBalanceMapping() {
  const [relationshipType] = useState([
    { label: 'Group - Entity', value: '1', value1: 'groups', value2: 'entity' },
    { label: 'Entity - Division', value: '2', value1: 'entity', value2: 'divisions' },
    { label: 'Division - Department', value: '3', value1: 'divisions', value2: 'departments' },
  ]);

  const [selectedRelationshipType, setSelectedRelationshipType] = useState(null);
  const [relationParent, setRelationParent] = useState("");
  const [relationChild, setRelationChild] = useState("");

  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [fileModalOpen1, setFileModalOpen1] = useState(false);

  const [childOptions, setChildOptions] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);

  const [parentTbOptions, setParentTbOptions] = useState([]);
  const [selectedParentTb, setSelectedParentTb] = useState(null);

  const [parentDetails, setParentDetails] = useState({});
  const [childGlOptions, setChildGlOptions] = useState([]);
  const [selectedChildGlRows, setSelectedChildGlRows] = useState([]);

  const [selectedLeftOptionIds, setSelectedLeftOptionIds] = useState(new Set());
  const [selectedRightOptionIds, setSelectedRightOptionIds] = useState(new Set());

const tableInfo = {
  groups: { table: "groups", id: "group_id" },
  entity: { table: "entities", id: "entity_id" },
  divisions: { table: "divisions", id: "division_id" },
  departments: { table: "department", id: "department_id" },
};

  const fetchtabledetailsInfo = async (query, setField, status = "yes") => {
    const payload = { query };
    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;

      if (data && data.length > 0) {
        if (status === "no") {
          setField(data);
        } else {
          const keys = Object.keys(data[0]);
          const labelKey = keys.find((k) => k.toLowerCase().includes("name"));
          const valueKey = keys.find((k) => k.toLowerCase().includes("_id"));

          const formatted = data.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
            description: item.description || "-",
            ...item
          }));
          setField(formatted);
        }
      } else {
        setField([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setField([]);
    }
  };

  const handleFileUpload2 = () => {
    console.log("Parent Uploading file");
    if (!selectedFile) {
      alert("Please select a file.");
      return;
    }
    setFileModalOpen(false);
  };
const handleFileUpload = () => {
  if (!selectedFile || !relationParent || !selectedParent?.value) {
    alert("Please select a file and parent.");
    return;
  }

  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("schema_name", "gltest");
  formData.append("table", `${relationParent}_tb_master`);

  const FileUploadCredentials = FetchUploadGl ();
  axios
    .post(FileUploadCredentials[1], formData, {
      ...FileUploadCredentials[0],
      headers: {
        ...FileUploadCredentials[0].headers,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      console.log("Upload response:", response);
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error uploading file:", error);
    });

  setFileModalOpen(false);
};


  const handleFileUpload1 = () => {
  if (!selectedFile || !relationChild || !selectedChild?.value) {
    alert("Please select a file and child.");
    return;
  }

  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("schema_name", "gltest");
  formData.append("table", `${relationChild}_tb_master`);

  const FileUploadCredentials = FetchUploadGl();
  axios
    .post(FileUploadCredentials[1], formData, {
      ...FileUploadCredentials[0],
      headers: {
        ...FileUploadCredentials[0].headers,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      console.log("Child file upload response:", response);
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error uploading child file:", error);
    });

  setFileModalOpen(false);
};

  const handleChildChange = (selected) => {
    setSelectedChild(selected);
    setSelectedChildGlRows([]);
    fetchtabledetailsInfo(
      `SELECT \`GL Code\` AS name, description,\`TB code\`,\`Financial caption\`, primary_id FROM gltest.${relationChild}_tb_master where group_map_id is null`,
      setChildGlOptions,'no'
    );
  };

  const handleUpdate = () => {
    const childIds = selectedChildGlRows.map((row) => row.primary_id);
    const payload = {
      schema_name: "gltest",
      table: "entity_tb_master",
      set_column: { "group_map_id": selectedParentTb?.primary_id },
      where: [{ primary_id: childIds }],
    };

    const FileUploadCredentials = Fetchupdatequery();
    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then((response) => {
        console.log("Update response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  };

  const handleUpdate1 = () => {
    const childIds = childGlOptions.map((row) => row.primary_id);
    const payload = {
      schema_name: "gltest",
      table: "entity_tb_master",
      set_column: { "group_map_id": null },
      where: [{ primary_id: childIds }],
    };

    const FileUploadCredentials = Fetchupdatequery();
    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then((response) => {
        console.log("Update response:", response);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  };



  const handleRelationshipTypeChange = async (selected) => {
    const parent = selected.value1;
    const child = selected.value2;
    setSelectedRelationshipType(selected);
    setRelationParent(parent);
    setRelationChild(child);
    setSelectedParent(null);
    setSelectedChild(null);
    setSelectedParentTb(null);
    setSelectedChildGlRows([]);

console.log(child,selected)
const selected1 = tableInfo[child];
let childQuery  = ''
if (!selected1) {
  console.error("Invalid child type");
} else {
  childQuery = `SELECT name, ${selected1.id} FROM user_management_uat.${selected1.table} WHERE is_active=1`;
  console.log(childQuery);
}

    const parentQuery = `SELECT name, ${parent === "entities" ? "entity_id" : parent + "_id"} FROM user_management_uat.${parent === "entity" ? "entities" : parent} WHERE is_active=1`;
    // const childQuery = `SELECT name, ${child === "entity" ? "entity_id" : child + "_id"} FROM user_management_uat.${child === "entity" ? "entities" : child } WHERE is_active=1`;

    await fetchtabledetailsInfo(parentQuery, setParentOptions);
    await fetchtabledetailsInfo(childQuery, setChildOptions);
  };

  const handleParentChange = (selected) => {
    setSelectedParent(selected);
    console.log("selected",selected.value)
    setSelectedParentTb(null);
    if (relationParent === "groups") {
      fetchtabledetailsInfo(
        `SELECT \`GL Code\` AS name, description,\`TB code\`,\`Financial caption\`, primary_id FROM gltest.group_tb_master where group_id = ${selected.value}`,
        setParentTbOptions,'no'
      );
    } else if (relationParent === "entities") {
      fetchtabledetailsInfo(
        `SELECT \`GL Code\` AS name, primary_id, description FROM gltest.entities_tb_master`,
        setParentTbOptions
      );
    }
  };

  const handleParentTBChange = (selected) => {
    setSelectedParentTb(selected);
    console.log(selected)
    fetchtabledetailsInfo(
      `SELECT \`GL code\`,\`TB code\`,\`Financial caption\`,\`Schedule classification\`,\`Nature of Ledger\` FROM gltest.group_tb_master WHERE primary_id = ${selected.primary_id}`,
      setParentDetails,
      'no'
    );

    fetchtabledetailsInfo(
      `SELECT \`GL code\` as name, description, primary_id FROM gltest.entity_tb_master WHERE group_map_id = ${selected.primary_id}`,
      setSelectedChildGlRows,
      'no'
    );
  };

  const handleTransferSelectedRows = () => {
    const selectedRows = childGlOptions.filter(row => selectedLeftOptionIds.has(row.primary_id));
    setSelectedChildGlRows(prev => [...prev, ...selectedRows]);
    setChildGlOptions(prev => prev.filter(row => !selectedLeftOptionIds.has(row.primary_id)));
    setSelectedLeftOptionIds(new Set());
  };

  const handleRemoveSelectedRows = () => {
    const selectedRows = selectedChildGlRows.filter(row => selectedRightOptionIds.has(row.primary_id));
    setChildGlOptions(prev => [...prev, ...selectedRows]);
    setSelectedChildGlRows(prev => prev.filter(row => !selectedRightOptionIds.has(row.primary_id)));
    setSelectedRightOptionIds(new Set());
  };

  return (
    <div style={{ padding: 20 }}>
      {/* Form Section */}
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>Trial Balance Code Mapping</h2>
      <div style={{ display: "flex", gap: "20px" }}>
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20, marginBottom: 20 }}>
            <div style={{ width: '250px' }}>
              <label>Relationship Type</label>
              <Select options={relationshipType} value={selectedRelationshipType} onChange={handleRelationshipTypeChange} />
            </div>

            <div style={{ width: '250px' }}>
              <label>Parent</label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Select
                  options={parentOptions}
                  value={selectedParent}
                  onChange={handleParentChange}
                  isDisabled={!selectedRelationshipType}
                  styles={{ container: base => ({ ...base, flex: 1 }) }}
                />
              </div>
            </div>
            <div style={{ width: '250px' }}>
              <label>Child</label>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Select
                  options={childOptions}
                  value={selectedChild}
                  onChange={handleChildChange}
                  isDisabled={!selectedRelationshipType}
                  styles={{ container: base => ({ ...base, flex: 1 }) }}
                />
              </div>
            </div>


          </div>

          <div style={{ display: "flex", gap: 20, alignItems: 'flex-end' }}>
            <div>
              <button type="button" className="submit-btn" onClick={handleUpdate1}>Save</button>
            </div>
          </div>
        </div>

        {/* Parent TB Details */}
        {parentDetails && Object.keys(parentDetails).length > 0 && (
          <div style={{
            flex: 2,
            backgroundColor: "#f9f9f9",
            border: "1px solid #ccc",
            padding: 10,
            borderRadius: 6,
            height: "fit-content"
          }}>
            <div style={{ fontWeight: "bold", marginBottom: 8 }}>{selectedParent?.label} Trial Balance Details:</div>
            {Object.entries(parentDetails[0] || {}).map(([k, v]) => (
              <div key={k}><strong>{k.replace(/_/g, ' ')}:</strong> {v || '-'}</div>
            ))}
          </div>
        )}
      </div>

      {/* Mapping Tables */}
      <div style={{ display: "flex", gap: 20, marginTop: 20 }}>
<div className="ag-theme-alpine" style={{ flex: 1, height: 500 }}>
  <AgGridReact
    rowData={parentTbOptions}
    columnDefs={[
      {
        headerName: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 50,
      },
      ...Object.keys(parentTbOptions[0] || {}).filter(key => key !== 'label' && key !== 'value').map(key => ({
        headerName: key,
        field: key,
        sortable: true,
        filter: true,
        resizable: true
      }))
    ]}
    rowSelection="single"
    onSelectionChanged={(e) => {
      const selectedRow = e.api.getSelectedNodes()[0]?.data;
      if (selectedRow) handleParentTBChange(selectedRow);
    }}
  />
</div>

        {/* Left Table */}
        <div className="ag-theme-alpine" style={{ flex: 1, height: 500 }}>
          <AgGridReact
            rowData={childGlOptions}
            columnDefs={[
              { headerName: '', checkboxSelection: true, headerCheckboxSelection: true, width: 50 },
              ...Object.keys(childGlOptions[0] || {}).filter((key) => key !== 'label' && key !== 'value').map((key) => ({
                headerName: key,
                field: key,
                sortable: true,
                filter: true
              }))
            ]}
            rowSelection="multiple"
            onSelectionChanged={(e) => {
              const selected = e.api.getSelectedNodes().map((node) => node.data.primary_id);
              setSelectedLeftOptionIds(new Set(selected));
            }}
          />
              <button type="button" className="submit-btn" onClick={handleTransferSelectedRows}>Map Selected</button>

        </div>

        {/* Right Table */}
        <div className="ag-theme-alpine" style={{ flex: 1, height: 500 }}>
          <AgGridReact
            rowData={selectedChildGlRows}
            columnDefs={[
              { headerName: '', checkboxSelection: true, headerCheckboxSelection: true, width: 50 },
              ...Object.keys(selectedChildGlRows[0] || {}).filter((key) => key !== 'label' && key !== 'value').map((key) => ({
                headerName: key,
                field: key,
                sortable: true,
                filter: true,
                resizable: true,
              }))
            ]}
            rowSelection="multiple"
            onSelectionChanged={(e) => {
              const selected = e.api.getSelectedNodes().map((node) => node.data.primary_id);
              setSelectedRightOptionIds(new Set(selected));
            }}
          />
          <button type="button" className="submit-btn" onClick={handleRemoveSelectedRows}>Unmap Selected</button>

        </div>
      </div>


    </div>
  );
}

export default TrialBalanceMapping;
